import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        productLinkFeature: {
          module: () => import('./product-link.module').then((m) => m.ProductLinkModule),
        },
      }
    }),
  ]
})
export class ProductLinkFeatureModule {}
